import React, { ReactElement } from "react";
import { ListTableColumn, createListTableColumns, renderEnumValue, renderName } from "sprint-common-web";

import { WatermarkRulePosition } from "../../../common/types/WatermarkRulePosition";
import { DeleteWatermarkRuleButton } from "./buttons/delete/DeleteWatermarkRuleButton";
import { EditWatermarkRuleButton } from "./buttons/edit/EditWatermarkRuleButton";
import { WatermarkRuleItem } from "./WatermarkRuleItem";

export const createWatermarkRuleListingColumns = (): ListTableColumn<WatermarkRuleItem>[] => {
    return createListTableColumns<WatermarkRuleItem>([
        {
            type: "basic",
            key: "value",
            name: "Airline value",
            minWidth: 180,
            maxWidth: 350,
            isSortable: true
        },
        {
            type: "basic",
            key: "distributor",
            name: "Distributor",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            onRender: renderName
        },
        {
            type: "basic",
            key: "position",
            name: "Position",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            onRender: renderWatermarkRulePosition
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 197,
            maxWidth: 197,
            isResizable: false,
            buttons: [
                {
                    id: "editWatermarkRule",
                    render: EditWatermarkRuleButton
                },
                {
                    id: "deleteWatermarkRule",
                    render: DeleteWatermarkRuleButton
                }
            ]
        }
    ]);
};

export const renderWatermarkRulePosition = (
    item?: WatermarkRuleItem,
    _index?: number,
    column?: ListTableColumn<WatermarkRuleItem>
): ReactElement | null => {
    return renderEnumValue(WatermarkRulePosition, item, _index, column);
};
